import { ApiClient } from '../apiClient';
import type { KycStartResponse, KycStatusResponse } from '../../types/kyc';

// Identity verification (BE: /user/kyc). start() creates or resumes an
// Ondato session and returns the hosted-flow URL; the verdict arrives at the
// backend by webhook, so the cart polls status() until it flips.
export class KycService {
  constructor(private apiClient: ApiClient) {}

  async start(): Promise<KycStartResponse> {
    return this.apiClient.post<KycStartResponse>('/user/kyc/start', {});
  }

  async status(): Promise<KycStatusResponse> {
    return this.apiClient.get<KycStatusResponse>('/user/kyc/status');
  }
}
